import { createEffect } from 'effector';

export const createShowAlertFx = (name: string) =>
  createEffect((value: unknown) => {
    console.error(name, value);
    window.alert(name + '\nDetails in console:\n' + JSON.stringify(value, undefined, '  '));
  });
